import { duressService } from "client-app-core";
import * as t from "./actionTypes";

const duressStatusReceived = (data) => {
	return {
		type: t.DURESS_STATUS_RECEIVED,
		payload: data
	};
};

export const subscribeToDuressStatus = () => {
	return (dispatch) => {
		duressService.streamDuressAlarmStatus((err, res) => {
			if (err) console.log(err);
			if (!res) return;
			dispatch(duressStatusReceived(res));
		});
	};
};
